// tslint:disable
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// tslint:enable
import { UsernameAttributes } from '../types';
import { Component, Input, Inject } from '@angular/core';
import { AmplifyService } from '../../../providers/amplify.service';
import { auth } from '../../../assets/data-test-attributes';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '../../../providers/amplify.service';

function GreetingComponentCore_div_0_Template(rf, ctx) { if (rf & 1) {
    var _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "a", 4);
    ɵngcc0.ɵɵlistener("click", function GreetingComponentCore_div_0_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); var ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.onSignOut(); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.greeting);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.amplifyService.i18n().get("Sign Out"));
} }
var template = "\n<div class=\"amplify-greeting\" *ngIf=\"signedIn\">\n    <div class=\"amplify-greeting-text\">{{ greeting }}</div>\n    <div class=\"amplify-greeting-flex-spacer\"></div>\n    <a class=\"amplify-form-link amplify-greeting-sign-out\"\n      (click)=\"onSignOut()\"\n      data-test=\"" + auth.greeting.signOutButton + "\"\n    >{{ this.amplifyService.i18n().get('Sign Out') }}</a>\n</div>\n";
var GreetingComponentCore = /** @class */ (function () {
    function GreetingComponentCore(amplifyService) {
        this.amplifyService = amplifyService;
        this._usernameAttributes = 'username';
        this.logger = this.amplifyService.logger('GreetingComponent');
        this.subscribe();
    }
    Object.defineProperty(GreetingComponentCore.prototype, "usernameAttributes", {
        set: function (usernameAttributes) {
            this._usernameAttributes = usernameAttributes;
        },
        enumerable: true,
        configurable: true
    });
    GreetingComponentCore.prototype.ngOnInit = function () {
        if (!this.amplifyService.auth()) {
            throw new Error('Auth module not registered on AmplifyService provider');
        }
    };
    GreetingComponentCore.prototype.subscribe = function () {
        var _this = this;
        this.amplifyService.authStateChange$.subscribe(function (state) {
            return _this.setAuthState(state);
        });
    };
    GreetingComponentCore.prototype.setAuthState = function (authState) {
        this.authState = authState;
        this.signedIn = authState.state === 'signedIn';
        var username = '';
        if (authState.user) {
            if (this._usernameAttributes === UsernameAttributes.EMAIL) {
                username = authState.user.attributes
                    ? authState.user.attributes.email
                    : authState.user.username;
            }
            else if (this._usernameAttributes === UsernameAttributes.PHONE_NUMBER) {
                username = authState.user.attributes
                    ? authState.user.attributes.phone_number
                    : authState.user.username;
            }
            else {
                username = authState.user.username;
            }
        }
        this.greeting = this.signedIn
            ? this.amplifyService
                .i18n()
                .get('Hello, {{username}}')
                .replace('{{username}}', username)
            : '';
    };
    GreetingComponentCore.prototype.onSignOut = function () {
        this.amplifyService.auth().signOut();
    };
    /** @nocollapse */
    GreetingComponentCore.ctorParameters = function () { return [
        { type: AmplifyService, decorators: [{ type: Inject, args: [AmplifyService,] },] },
    ]; };
    GreetingComponentCore.propDecorators = {
        "authState": [{ type: Input },],
        "usernameAttributes": [{ type: Input },],
    };
GreetingComponentCore.ɵfac = function GreetingComponentCore_Factory(t) { return new (t || GreetingComponentCore)(ɵngcc0.ɵɵdirectiveInject(AmplifyService)); };
GreetingComponentCore.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GreetingComponentCore, selectors: [["amplify-auth-greetings-core"]], inputs: { usernameAttributes: "usernameAttributes", authState: "authState" }, decls: 1, vars: 1, consts: [["class", "amplify-greeting", 4, "ngIf"], [1, "amplify-greeting"], [1, "amplify-greeting-text"], [1, "amplify-greeting-flex-spacer"], ["data-test", "sign-out-button", 1, "amplify-form-link", "amplify-greeting-sign-out", 3, "click"]], template: function GreetingComponentCore_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, GreetingComponentCore_div_0_Template, 6, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.signedIn);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GreetingComponentCore, [{
        type: Component,
        args: [{
                selector: 'amplify-auth-greetings-core',
                template: template
            }]
    }], function () { return [{ type: ɵngcc2.AmplifyService, decorators: [{
                type: Inject,
                args: [AmplifyService]
            }] }]; }, { usernameAttributes: [{
            type: Input
        }], authState: [{
            type: Input
        }] }); })();
    return GreetingComponentCore;
}());
export { GreetingComponentCore };

